import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {DelegationService} from 'src/app/shared/services/delegation.service';
import {map} from 'rxjs/operators';
import {Delegation} from 'src/app/shared/models/delegation.model';
import {TableDataSource} from 'src/app/shared/components/table/table-data-source';
import {tableSortFn} from 'src/app/shared/utils/sort.util';
import {CostStatuses} from '../../../shared/models/cost.model';
import {Employee} from '../../../shared/models/employee.model';
import {EmployeeService} from '../../../shared/services/employee.service';

@Component({
  selector: 'app-delegations-employees',
  templateUrl: './delegations-archives.component.html'
})
export class DelegationsArchivesComponent implements OnInit {
  readonly delegationStatuses = CostStatuses;
  delegations: Delegation[];
  delegations$;
  employees$;
  dataSource = new TableDataSource<Delegation>();
  displayedColumns: string[] = ['employee.person.lastName', 'delegationNumber', 'status.name', 'createdAt', 'advance.name', 'grossValue', 'forwardedToPaymentAt', 'returnedAt', 'action'];

  @ViewChild(MatSort, {static: false}) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private serviceDelegation: DelegationService,
    private employeeService: EmployeeService,
  ) {
  }

  ngOnInit() {
    this.delegations$ = this.serviceDelegation.fetchDelegationsByStatus(CostStatuses.Settled)
      .pipe(
        map((delegations: Delegation[]) => {
          this.delegations = this.dataSource.data = delegations;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return delegations;
        })
      );
    this.employees$ = this.employeeService.activeEmployees$;
  }

  onSelectEmployee(employee: Employee) {
    if (employee) {
      this.dataSource.data = this.delegations.filter((delegation: any) => delegation.employee.id === employee.id);
      return;
    }
    this.dataSource.data = this.delegations;
  }

}
